import { createFileRoute } from "@tanstack/react-router"
import { AdminUserDetailPage } from "@/components/pages/AdminUserDetailPage"

// `/admin/users/$userId` — the standalone user-detail page (replaces the old
// modal). Auth/admin guard is inherited from the parent admin layout's
// beforeLoad. Deep-linkable and refreshable: the page fetches the user itself.
function RouteComponent() {
  const { userId } = Route.useParams()
  return <AdminUserDetailPage userId={userId} />
}

export const Route = createFileRoute(`/_authenticated/admin/users/$userId`)({
  component: RouteComponent,
  ssr: false,
})
